import { render, staticRenderFns } from "./FifteenDays.vue?vue&type=template&id=b897d5e0&scoped=true&"
import script from "./FifteenDays.vue?vue&type=script&lang=js&"
export * from "./FifteenDays.vue?vue&type=script&lang=js&"
import style0 from "./FifteenDays.vue?vue&type=style&index=0&id=b897d5e0&prod&scoped=true&lang=css&"
import style1 from "./FifteenDays.vue?vue&type=style&index=1&id=b897d5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b897d5e0",
  null
  
)

export default component.exports